/**
 * Phone + SMS verification-code auth helpers.
 *
 * Mirrors the social-auth pattern: the backend owns the SMS + code verification
 * (see backend/src/routes/phoneAuth.ts). The code IS the credential for login and
 * register, so those calls are public. /bind is the only authenticated call.
 *
 * Endpoints are env-gated server-side; if SMS is not configured the front-end
 * simply never shows the phone tab (see fetchPhoneAuthConfig).
 */
import { API_URL } from '../config/env';

const BASE = `${API_URL.replace(/\/$/, '')}/auth/phone`;

/** Capability flag: is a real SMS provider wired up? */
export async function fetchPhoneAuthConfig() {
  try {
    const res = await fetch(`${BASE}/config`, {
      headers: { Accept: 'application/json' },
      credentials: 'include',
    });
    if (!res.ok) return { enabled: false };
    const data = await res.json().catch(() => ({}));
    return {
      enabled: Boolean(data?.enabled),
      simulated: Boolean(data?.simulated),
      provider: data?.provider,
    };
  } catch {
    return { enabled: false };
  }
}

async function post(path, body, token) {
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* no body */
  }
  return { ok: res.ok, status: res.status, data };
}

export function requestPhoneCode(phone, purpose = 'login') {
  return post('/code', { phone, purpose });
}

export function phoneRegister({ phone, code, password, name }) {
  return post('/register', { phone, code, password, name });
}

export function phoneLogin({ phone, code }) {
  return post('/login', { phone, code });
}

export function phonePasswordLogin({ phone, password }) {
  return post('/password-login', { phone, password });
}

export function phoneBind({ phone, code }, token) {
  return post('/bind', { phone, code }, token);
}

export default fetchPhoneAuthConfig;
